import { render, staticRenderFns } from "./Buckets.vue?vue&type=template&id=ef8d2d00&"
import script from "./Buckets.vue?vue&type=script&lang=js&"
export * from "./Buckets.vue?vue&type=script&lang=js&"
import style0 from "./Buckets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports